import { useState, useCallback } from 'react';
import { createEngagementClient } from '../../../../src/services/client';
import { ADD_FAVORITE_CONTENT } from '../engagementGql/favoriteContent';
import { addErrorInDatadogRum } from '../utils/utilities';

const PROGRAM_CONTENT_TYPE = 'program';

const useAddFavoriteProgram = () => {
  const [isProcessing, setIsProcessing] = useState(false);

  const addFavoriteProgram = useCallback(async (programName: string) => {
    setIsProcessing(true);
    try {
      await createEngagementClient.mutate({
        mutation: ADD_FAVORITE_CONTENT,
        variables: {
          contentType: PROGRAM_CONTENT_TYPE,
          contentId: programName,
        },
      });
    } catch (err) {
      addErrorInDatadogRum(err);
    } finally {
      setIsProcessing(false);
    }
  }, []);

  return { addFavoriteProgram, isProcessing };
};

export default useAddFavoriteProgram;
